











































































































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueFieldGroup from '@/components/Shared/SaascadaVueForm';
import ProductState from '@/components/Products/ProductState.vue';
import DepositPaymentOrderSettings from "@/models/Products/ProductSettings/DefaultSettings/PaymentOrders/DepositPaymentOrderSettings";
import DepositPaymentOrderSettingsEditDialog from '@/components/Products/ProductSettings/DefaultSettings/PaymentOrders/DepositPaymentOrderSettingsEditDialog.vue';
import EntityType from '@/models/Shared/EntityType';
import PermissionUtils from '@/lib/permissionUtils';

@Component({ name: 'DepositPaymentOrderSettingsRead', components: { ProductState, DepositPaymentOrderSettingsEditDialog } })
export default class extends SaascadaVueFieldGroup {

    EntityType = EntityType;
    PermissionUtils = PermissionUtils;

    @Prop({required: true })
    settings: DepositPaymentOrderSettings;

    @Prop({required: true})
    entityType: EntityType;

    get settingsAvailable() {
        return (this.settings !== undefined);
    }
}
